import React from 'react';

interface SuccessCheckIconProps {
  className?: string;
}

export const SuccessCheckIcon: React.FC<SuccessCheckIconProps> = ({ className }) => {
  return (
    <div
      className={`bg-ds-bg-surface-2 flex items-center justify-center rounded-full ${className ?? ''}`}
      style={{ width: 80, height: 80 }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
      >
        <path
          d="M26.1381 8.3305C26.564 7.88987 27.2548 7.8898 27.6807 8.3305C28.1066 8.77178 28.1063 9.48891 27.6807 9.93039L13.135 25.002L13.0526 25.08C13.0242 25.104 12.9945 25.1257 12.9645 25.1462C12.8435 25.2291 12.7101 25.2849 12.5725 25.3125C12.2629 25.3748 11.9319 25.2973 11.6747 25.08L11.5923 25.002L4.31947 17.4662C3.89347 17.0248 3.89355 16.3092 4.31947 15.8678C4.7455 15.4263 5.43607 15.4263 5.86211 15.8678L12.3622 22.6029L26.1381 8.3305Z"
          className="fill-white"
        />
      </svg>
    </div>
  );
};

export default SuccessCheckIcon;
